export default "<crms-regulatories  [hideTab]=\"hideTab\" [isLms]=\"isLms\"  >\r\n</crms-regulatories>"